module.exports = __webpack_public_path__ + "img/bgVendas.53db7b04.png";